import i18next from "i18next"
import {
  getFieldRequiredMessage,
  getPersonNameInvalidCharsMessage,
  getPersonNameMinLengthMessage,
  getPersonNameMustHaveLetterMessage,
} from "components/Common/validationMessages"

/** Max length for person first, last, and full name fields. */
export const PERSON_NAME_MAX_LENGTH = 100
export const PERSON_NAME_MIN_LENGTH = 2

/** Latin or Arabic letters; spaces; hyphen, apostrophe, period. */
const personNamePattern = /^[\u0621-\u064Aa-zA-Z\s\-'.]+$/
const personNameLetterPattern = /[\u0621-\u064Aa-zA-Z]/

/**
 * Shared person-name check for portal forms.
 * Returns a translated error, or "" when the value is acceptable.
 */
export const validatePersonName = (value, { required = true } = {}) => {
  const trimmed = String(value ?? "").trim()
  if (!trimmed) {
    return required ? getFieldRequiredMessage() : ""
  }
  if (trimmed.length < PERSON_NAME_MIN_LENGTH) {
    return getPersonNameMinLengthMessage()
  }
  if (trimmed.length > PERSON_NAME_MAX_LENGTH) {
    return i18next.t("Name cannot exceed 100 characters")
  }
  if (!personNamePattern.test(trimmed)) {
    return getPersonNameInvalidCharsMessage()
  }
  if (!personNameLetterPattern.test(trimmed)) {
    return getPersonNameMustHaveLetterMessage()
  }
  return ""
}
